import { MatCheckboxChange } from '@angular/material/checkbox';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
})
export class CheckboxComponent implements OnInit {
  @Input() label: string;

  @Input() disabled: boolean;

  @Input() defaultValue: boolean;

  @Input() formControlName: string;

  @Output() Change: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output() Click: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {}

  onChange(event: MatCheckboxChange) {
    this.Change.emit(event.checked);
  }

  onClick() {
    this.Click.emit();
  }
}
